import CTAForm from "../../components/InvestmentPlanning/CTAForm";
import Hero from "../../components/InvestmentPlanning/Hero";
import KeyTakeawaysSection from "../../components/InvestmentPlanning/KeyTakeawaysSection";
import Disclaimer from "../../components/retirement-planning/Disclaimer";

export default function InvestmentPlanningNew() {
    return (
        <>
            <Hero />
            <KeyTakeawaysSection />
            <CTAForm/>
            <Disclaimer/>
        </>
    )
}